<template>
  <div class="smb-sales_container">
    <div
      class="smb-sales_container_title"
      v-if="isApply || isEdit || isRenew || isResubmit"
    >
      Sales Target Information
    </div>
    <div class="smb-sales_container_title" v-if="isDetail || isSeniorEditApprove">
      Sales Target Information
    </div>
    <div
      class="smb-sales_container_content"
      v-if="isApply || isEdit || isRenew || isResubmit"
    >
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :disabled="isEdit && !isSenior"
      >
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="assessmenType" v-if="isShowAssessmentMethod">
            <template #label>
              <div class="smbsales-label_required">
                Assessment Method
                <el-tooltip placement="top-start" effect="light" offset="45">
                  <img
                    src="@/assets/tool-tip_icon.svg"
                    width="18px"
                    height="18px"
                    alt=""
                  />
                  <template #content>
                    <div class="text-content">
                      <div>
                        <strong>Overall Assessment</strong>Fill in only the
                        total sales target. Rebate levels are determined by the
                        total annual sales performance.
                      </div>
                      <div>
                        <strong>Separate Assessment</strong> Set individual
                        annual sales targets for Enterprise, Reyee, and Home
                        Wi-Fi products. Each product line's rebate level is
                        based on its respective sales target.
                      </div>
                    </div>
                  </template>
                </el-tooltip>
              </div>
            </template>
            <el-radio-group
              v-model="formData.assessmenType"
              @change="handleAssessmentTypeChange"
            >
              <el-radio :label="1">
                Overall Assessment
              </el-radio>
              <el-radio :label="2">
                Separate Assessment
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="total">
            <template #label>
              <div class="form-container_label">
                Total Sales Target (USD)
              </div>
            </template>
            <div>{{ toThousands(totalTarget) }}</div>
          </el-form-item>
        </div>
        <div class="smb-sales_container_table p-0">
          <el-form-item prop="tableList">
            <el-table border :data="formData.tableList">
              <el-table-column label="Target Type" prop="targetType" show-overflow-tooltip />
              <el-table-column label="Total (USD)" prop="total">
                <template v-slot:default="{ row, $index }">
                  <el-form-item
                    :prop="`tableList.${$index}.total`"
                    :rules="[
                      {
                        required: true,
                        message: 'please input total',
                        trigger: ['blur'],
                        type: 'number'
                      }
                    ]"
                  >
                    <el-input-number
                      v-model="row.total"
                      :controls="false"
                      :min="0"
                      :precision="0"
                      @change="handleTableListTotalChange(row)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Q1" prop="q1">
                <template v-slot:default="{ row, $index }">
                  <el-form-item
                    :prop="`tableList.${$index}.q1`"
                    :rules="[
                      {
                        required: true,
                        message: 'please input q1',
                        trigger: ['change', 'blur'],
                        type: 'number'
                      }
                    ]"
                  >
                    <el-input-number
                      v-model="row.q1"
                      :controls="false"
                      :min="0"
                      :precision="0"
                      @change="handleTableListQChange(row, true)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Q2" prop="q2">
                <template v-slot:default="{ row, $index }">
                  <el-form-item
                    :prop="`tableList.${$index}.q2`"
                    :rules="[
                      {
                        required: true,
                        message: 'please input q2',
                        trigger: ['change', 'blur'],
                        type: 'number'
                      }
                    ]"
                  >
                    <el-input-number
                      v-model="row.q2"
                      :controls="false"
                      :min="0"
                      :precision="0"
                      @change="handleTableListQChange(row, true)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Q3" prop="q3">
                <template v-slot:default="{ row, $index }">
                  <el-form-item
                    :prop="`tableList.${$index}.q3`"
                    :rules="[
                      {
                        required: true,
                        message: 'please input q3',
                        trigger: ['change', 'blur'],
                        type: 'number'
                      }
                    ]"
                  >
                    <el-input-number
                      v-model="row.q3"
                      :controls="false"
                      :min="0"
                      :precision="0"
                      @change="handleTableListQChange(row, true)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Q4" prop="q4">
                <template v-slot:default="{ row, $index }">
                  <el-form-item
                    :prop="`tableList.${$index}.q4`"
                    :rules="[
                      {
                        required: true,
                        message: 'please input q4',
                        trigger: ['change', 'blur'],
                        type: 'number'
                      }
                    ]"
                  >
                    <el-input-number
                      v-model="row.q4"
                      :controls="false"
                      :min="0"
                      :precision="0"
                      @change="handleTableListQChange(row, true)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Rebate Level" prop="rebateLevel" show-overflow-tooltip>
                <template v-slot:default="{ row, $index }">
                  {{
                    Big(getNum(row.rebateLevel || 0))
                      .times(100)
                      .toFixed(2) + "%"
                  }}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="smb-sales_container_content" v-if="isDetail">
      <el-row>
        <el-col :span="12" v-if="detailData.partnerType === 'VAD'">
          <div class="smb-sales_label">Assessment Method</div>
          <div class="smb-sales_value" v-if="detailData.assessmenType === 1">
            Overall Assessment
          </div>
          <div
            class="smb-sales_value"
            v-else-if="detailData.assessmenType === 2"
          >
            Separate Assessment
          </div>
          <div v-else class="smb-sales_value">-</div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Total Sales Target (USD)</div>
          <div class="smb-sales_value">
            {{ getDetailTotal(detailData.targetTotal) }}
          </div>
        </el-col>
      </el-row>
      <el-table border :data="detailTableList" style="margin-top: 15px;">
        <el-table-column label="Target Type" prop="targetType" />
        <el-table-column label="Total (USD)" prop="total" align="right" />
        <el-table-column label="Q1" prop="q1" align="right" />
        <el-table-column label="Q2" prop="q2" align="right" />
        <el-table-column label="Q3" prop="q3" align="right" />
        <el-table-column label="Q4" prop="q4" align="right" />
        <el-table-column label="Rebate Level" align="right" prop="rebateLevel">
          <template v-slot:default="{ row, $index }">
            <span v-if="row.rebateLevel === 0 || row.rebateLevel">
              {{
                Big(getNum(row.rebateLevel || 0))
                  .times(100)
                  .toFixed(2) + "%"
              }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="smb-sales_container_content" v-if="isSeniorEditApprove">
      <el-row :gutter="20">
        <el-col :span="12" v-if="detailData.partnerType === 'VAD'">
          <div class="smb-sales_label">Assessment Method</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('assessmenType')">
              <span class="new-value">
                {{ getAssessmentMethod(detailData.assessmenType)  }}
              </span>
              <span class="old-value padding-left_6">{{ oldEditDetail['assessmenType'] ? `(${getAssessmentMethod(getNum(oldEditDetail['assessmenType']))})` : void 0 }}</span>
            </div>
            <template v-else>
              {{  getAssessmentMethod(detailData.assessmenType) }}
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Total Sales Target (USD)</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('targetTotal')">
              <span class="new-value">
                {{ getDetailTotal(detailData.targetTotal)  }}
              </span>
              <span class="old-value padding-left_6">{{ oldEditDetail['targetTotal'] ? `(${getDetailTotal(oldEditDetail['targetTotal'])})` : void 0 }}</span>
            </div>
            <template v-else>
              {{  getDetailTotal(detailData.targetTotal) || "-" }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-table border :data="detailTableList" style="margin-top: 15px;">
        <el-table-column label="Target Type" prop="targetType" />
        <el-table-column label="Total (USD)" prop="total" align="right">
          <template v-slot:default="{ row, $index }">
            <template v-if="oldEditDetail.hasOwnProperty(row.totalFiledName)">
              <span class="new-value">{{ getNum(detailData[row.totalFiledName]) }}</span>
              <span class="old-value padding-left_6">{{ oldEditDetail[row.totalFiledName] ? `(${ getNum(oldEditDetail[row.totalFiledName]) })`: 0 }}</span>
            </template>
            <template v-else>
              {{ getNum(detailData[row.totalFiledName]) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Q1" prop="q1" align="right">
          <template v-slot:default="{ row, $index }">


            <template v-if="oldEditDetail.hasOwnProperty(row.q1FiledName)">
              <span class="new-value">{{ getNum(detailData[row.q1FiledName]) }}</span>
              <span class="old-value padding-left_6">{{ oldEditDetail[row.q1FiledName] ? `(${ getNum(oldEditDetail[row.q1FiledName]) })`: 0 }}</span>
            </template>
            <template v-else>
              {{ getNum(detailData[row.q1FiledName]) }}
            </template>

          </template>
        </el-table-column>
        <el-table-column label="Q2" prop="q2" align="right">
          <template v-slot:default="{ row, $index }">


            <template v-if="oldEditDetail.hasOwnProperty(row.q2FiledName)">
              <span class="new-value">{{ getNum(detailData[row.q2FiledName]) }}</span>
              <span class="old-value padding-left_6">{{ oldEditDetail[row.q2FiledName] ? `(${ getNum(oldEditDetail[row.q2FiledName]) })`: 0 }}</span>
            </template>
            <template v-else>
              {{ getNum(detailData[row.q2FiledName]) }}
            </template>

          </template>
        </el-table-column>
        <el-table-column label="Q3" prop="q3" align="right">
          <template v-slot:default="{ row, $index }">
            <template v-if="oldEditDetail.hasOwnProperty(row.q3FiledName)">
              <span class="new-value">{{ getNum(detailData[row.q3FiledName]) }}</span>
              <span class="old-value padding-left_6">{{ oldEditDetail[row.q3FiledName] ? `(${ getNum(oldEditDetail[row.q3FiledName]) })`: 0 }}</span>
            </template>
            <template v-else>
              {{ getNum(detailData[row.q3FiledName]) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Q4" prop="q4" align="right">
          <template v-slot:default="{ row, $index }">
            <template v-if="oldEditDetail.hasOwnProperty(row.q4FiledName)">
              <span class="new-value">{{ getNum(detailData[row.q4FiledName]) }}</span>
              <span class="old-value padding-left_6">{{ oldEditDetail[row.q4FiledName] ? `(${ getNum(oldEditDetail[row.q4FiledName]) })`: 0 }}</span>
            </template>
            <template v-else>
              {{ getNum(detailData[row.q4FiledName]) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Rebate Level" prop="rebateLevel" align="right">
          <template v-slot:default="{ row, $index }">
            <template v-if="oldEditDetail.hasOwnProperty(row.rebateLevelFiledName)">
              <span class="new-value">{{ getPercentage(detailData[row.rebateLevelFiledName]) }}</span>
              <span class="old-value padding-left_6"> {{ oldEditDetail[row.rebateLevelFiledName] ? `(${ getPercentage(oldEditDetail[row.rebateLevelFiledName]) })` : void 0 }}</span>
            </template>
            <template v-else>
              {{ getPercentage(detailData[row.rebateLevelFiledName]) }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tools-tip" v-if="isApply || isRenew || isEdit">
      *Please enter the target in USD, not in KUSD
    </div>
  </div>
</template>

<script>
import { getCalculateTarget } from "@/api/international";
import { mapState } from "vuex";
import Big from "big.js";
import { getNum } from "@/utils/upload";
import dayjs from "dayjs";
import { toThousands } from "../../../utils";

export default {
  name: "salesTargetInformation",
  props: {
    // 编辑类型 基础 base 或者 高级senior 默认基础
    mode: {
      type: String,
      default: "base"
    },
    // 操作类型 申请 apply, 编辑 edit, 审批 approve， 默认申请
    type: {
      type: String,
      default: "apply"
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    },
    //是否是高级编辑审批页面
    isSeniorEditApprove: {
      type: Boolean,
      default: false
    },
    // 编辑修改后的数据
    oldEditDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        assessmenType: 1,
        total: 0, // 总共的数字
        // 分配比例
        tableList: [
          {
            targetType: "Enterprise",
            type: "Enterprise",
            total: 0,
            q1: 0,
            q2: 0,
            q3: 0,
            q4: 0,
            // 返利系数
            rebateLevel: ""
          },
          {
            targetType: "Reyee",
            type: "Reyee",
            total: 0,
            q1: 0,
            q2: 0,
            q3: 0,
            q4: 0,
            // 返利系数
            rebateLevel: ""
          },
          {
            targetType: "Home Wi-Fi",
            type: "Home",
            total: 0,
            q1: 0,
            q2: 0,
            q3: 0,
            q4: 0,
            // 返利系数
            rebateLevel: ""
          }
        ]
      },
      isInit: !this.isApply, // 是否初始化
      totalTarget: 0 // 总数
    };
  },
  computed: {
    dayjs() {
      return dayjs;
    },
    ...mapState("smbSales", ["selectCountryAndRegion", "partnerContractInfo"]),
    // 详情使用
    detailTableList() {
      return [
        {
          targetType: "Enterprise",
          type: "Enterprise",
          total: this.detailData.assignment,
          q1: this.detailData.saleTargetQ1,
          q2: this.detailData.saleTargetQ2,
          q3: this.detailData.saleTargetQ3,
          q4: this.detailData.saleTargetQ4,
          rebateLevel: this.detailData.rebateCoefficient,
          // 各个参数的字段名称 用于对比
          totalFiledName: 'assignment',
          q1FiledName: 'saleTargetQ1',
          q2FiledName: 'saleTargetQ2',
          q3FiledName: 'saleTargetQ3',
          q4FiledName: 'saleTargetQ4',
          rebateLevelFiledName: 'rebateCoefficient',
        },
        {
          targetType: "Reyee",
          type: "Reyee",
          total: this.detailData.reyeeTarget,
          q1: this.detailData.reyeeTargetQ1,
          q2: this.detailData.reyeeTargetQ2,
          q3: this.detailData.reyeeTargetQ3,
          q4: this.detailData.reyeeTargetQ4,
          rebateLevel: this.detailData.reyeeRebateCoefficient,
          // 各个参数的字段名称 用于对比
          totalFiledName: 'reyeeTarget',
          q1FiledName: 'reyeeTargetQ1',
          q2FiledName: 'reyeeTargetQ2',
          q3FiledName: 'reyeeTargetQ3',
          q4FiledName: 'reyeeTargetQ4',
          rebateLevelFiledName: 'reyeeRebateCoefficient',
        },
        {
          targetType: "Home Wi-Fi",
          type: "Home",
          total: this.detailData.homeTarget,
          q1: this.detailData.homeTargetQ1,
          q2: this.detailData.homeTargetQ2,
          q3: this.detailData.homeTargetQ3,
          q4: this.detailData.homeTargetQ4,
          rebateLevel: this.detailData.homeRebateCoefficient,
          // 各个参数的字段名称 用于对比
          totalFiledName: 'homeTarget',
          q1FiledName: 'homeTargetQ1',
          q2FiledName: 'homeTargetQ2',
          q3FiledName: 'homeTargetQ3',
          q4FiledName: 'homeTargetQ4',
          rebateLevelFiledName: 'homeRebateCoefficient',
        }
      ];
    },
    // 合作伙伴类型和合同有效期
    partnerTypeAndContractValidity() {
      return {
        partnerType: this.partnerContractInfo.partnerType,
        country: this.selectCountryAndRegion.country
      };
    },
    isShowAssessmentMethod() {
      return this.partnerContractInfo.partnerType === "VAD";
    },
    // 是否是高级编辑
    isSenior() {
      return this.mode === 'senior'
    }
  },
  watch: {
    partnerTypeAndContractValidity: {
      handler(value) {
        if (this.isInit) return; // 如果是初始化的时候 不触发
        if (!value.partnerType || !value.country) {
          return;
        }
        // 如果是VAD的时候 重新计算
        if (value.partnerType === "VAD") {
          this.formData.tableList.forEach(item => {
            this.getRebateLevel(item);
          });
        } else {
          this.formData.assessmenType = 1;
          this.getRebateLevelAll();
        }
      },
      deep: true
    }
  },
  methods: {
    toThousands,
    getNum,
    Big,

    // 当评估类型变化的时候
    handleAssessmentTypeChange(value, isParentApply) {
      if (this.isInit && !isParentApply) return; // 如果是初始化的时候 不触发
      if (value === 1) {
        this.getRebateLevelAll();
      } else {
        this.formData.tableList.forEach(item => {
          this.getRebateLevel(item);
        });
      }
    },

    // 全量考核模式下获取返利等级
    async getRebateLevelAll() {
      // 如果没有选择国家
      if (!this.selectCountryAndRegion.country) {
        this.$message.error("please select business registration country");
        return;
      }
      // 如果没有选择渠道类型
      if (!this.partnerTypeAndContractValidity.partnerType) {
        this.$message.error("please select partnerType");
        return;
      }
      const params = {
        country: this.partnerTypeAndContractValidity.country,
        productLineType: "All",
        partnerType: this.partnerTypeAndContractValidity.partnerType,
        totalTarget: this.totalTarget
      };
      await getCalculateTarget(params)
        .then(response => {
          let { status, data } = response;
          if (Number(status) === 200) {
            this.formData.tableList[0].rebateLevel = data.enterpriseFactor;
            this.formData.tableList[1].rebateLevel = data.reyeeFactor;
            this.formData.tableList[2].rebateLevel = data.homeFactor;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 非全量考核模式下获取返利等级
    async getRebateLevel(row) {
      // 如果没有选择国家
      if (!this.selectCountryAndRegion.country) {
        this.$message.error("please select business registration country");
        return;
      }
      // 如果没有选择渠道类型
      if (!this.partnerTypeAndContractValidity.partnerType) {
        this.$message.error("please select partnerType");
        return;
      }
      const params = {
        country: this.partnerTypeAndContractValidity.country,
        productLineType: row.type,
        partnerType: this.partnerTypeAndContractValidity.partnerType,
        totalTarget: row.total
      };
      await getCalculateTarget(params)
        .then(response => {
          let { status, data } = response;
          if (Number(status) === 200) {
            row.rebateLevel = data[row.type.toLowerCase() + "Factor"];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 设置formData
    setFormData(formData) {
      if (!formData) return;
      // 不会触发计算函数
      this.formData.assessmenType = formData.assessmenType;
      this.formData.tableList = [
        {
          targetType: "Enterprise",
          type: "Enterprise",
          total: formData.assignment,
          q1: formData.saleTargetQ1,
          q2: formData.saleTargetQ2,
          q3: formData.saleTargetQ3,
          q4: formData.saleTargetQ4,
          // 返利系数
          rebateLevel: formData.rebateCoefficient
        },
        {
          targetType: "Reyee",
          type: "Reyee",
          total: formData.reyeeTarget,
          q1: formData.reyeeTargetQ1,
          q2: formData.reyeeTargetQ2,
          q3: formData.reyeeTargetQ3,
          q4: formData.reyeeTargetQ4,
          // 返利系数
          rebateLevel: formData.reyeeRebateCoefficient
        },
        {
          targetType: "Home Wi-Fi",
          type: "Home",
          total: formData.homeTarget,
          q1: formData.homeTargetQ1,
          q2: formData.homeTargetQ2,
          q3: formData.homeTargetQ3,
          q4: formData.homeTargetQ4,
          // 返利系数
          rebateLevel: formData.homeRebateCoefficient
        }
      ];
      this.getTargetTotal();
      // 初始化完毕
      this.$nextTick(() => {
        this.isInit = false;
      });
    },
    // 获取formData
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => (isPass = isSuccess));
      if (!isPass) {
        return isPass;
      }
      return {
        // 如果是VAD的时候 传入的是对应的类型  传入的是All
        assessmenType: this.isShowAssessmentMethod
          ? this.formData.assessmenType
          : 1,
        // 销售目标
        assignment: this.formData.tableList[0].total || 0,
        saleTargetQ1: this.formData.tableList[0].q1 || 0,
        saleTargetQ2: this.formData.tableList[0].q2 || 0,
        saleTargetQ3: this.formData.tableList[0].q3 || 0,
        saleTargetQ4: this.formData.tableList[0].q4 || 0,
        // 系数
        rebateCoefficient: this.formData.tableList[0].rebateLevel || 0,
        // 易网络
        reyeeTarget: this.formData.tableList[1].total,
        reyeeTargetQ1: this.formData.tableList[1].q1 || 0,
        reyeeTargetQ2: this.formData.tableList[1].q2 || 0,
        reyeeTargetQ3: this.formData.tableList[1].q3 || 0,
        reyeeTargetQ4: this.formData.tableList[1].q4 || 0,
        reyeeRebateCoefficient: this.formData.tableList[1].rebateLevel || 0,
        // 家用网络
        homeTarget: this.formData.tableList[2].total || 0,
        homeTargetQ1: this.formData.tableList[2].q1 || 0,
        homeTargetQ2: this.formData.tableList[2].q2 || 0,
        homeTargetQ3: this.formData.tableList[2].q3 || 0,
        homeTargetQ4: this.formData.tableList[2].q4 || 0,
        homeRebateCoefficient: this.formData.tableList[2].rebateLevel || 0
      };
    },
    // 表格展示total
    getDetailTotal(total) {
      if (total === 0 || (getNum(total) === 0 && total !== null)) return 0;
      if (total) return toThousands(getNum(total));
      return "-";
    },
    // 当列表Q1 Q2 Q3 Q4变化的时候重新计算对应行的total
    handleTableListQChange(row, isTableListChange) {
      let keyList = ["q1", "q2", "q3", "q4"];
      row.total = keyList.reduce((previousValue, currentValue) => {
        if (isNaN(row[currentValue])) {
          return previousValue;
        } else {
          return previousValue + row[currentValue];
        }
      }, 0);
      this.getTargetTotal(); // 计算总数
      // total 计算完之后 如果是all 模式 就计算全部 返利系数， 但是如果是分开的模式 就需要分开计算返利系数
      this.handleTableListTotalChange(row, isTableListChange);
    },
    // 当列表项的total变化的时候重新计算
    handleTableListTotalChange(row, isTableListChange) {
      if (!row.total && row.total !== 0) {
        row.total = 0;
      }
      // 如果没有选择国家
      if (!this.selectCountryAndRegion.country) {
        this.$message.error("please select business registration country");
        return;
      }
      // 如果没有选择渠道类型
      if (!this.partnerTypeAndContractValidity.partnerType) {
        this.$message.error("please select partnerType");
        return;
      }

      // 如果是表格动季度数据的数据 那不需要赋值 就请求一下计算返利系数
      if (isTableListChange){
        if (this.formData.assessmenType===1) {
          this.getRebateLevelAll(); // 计算返利系数
        }else {
          this.getRebateLevel(row); // 计算单行返利系数
        }
      }
      // 如果不是表格懂得数据 那就需要赋值
      else {
        // 如果是all 计算当前行的
        if (this.formData.assessmenType===1) {
          // 如果是all 计算全部的返利系数， 并且计算当前行的分配
          const params = {
            country: this.partnerTypeAndContractValidity.country,
            productLineType: row.type,
            partnerType: this.partnerTypeAndContractValidity.partnerType,
            totalTarget: row.total
          };
          getCalculateTarget(params)
            .then(response => {
              let { status, data } = response;
              if (Number(status) === 200) {
                row.q1 = data.quarterlySplitVO.q1;
                row.q2 = data.quarterlySplitVO.q2;
                row.q3 = data.quarterlySplitVO.q3;
                row.q4 = data.quarterlySplitVO.q4;
                this.getTargetTotal(); // 计算总数
                this.getRebateLevelAll(); // 计算全部返利系数
              }
            })
            .catch(error => {
              console.log(error);
            });
        }else {
          // 如果不是all 计算当前行分配  以及全部的返利系数，
          const params = {
            country: this.partnerTypeAndContractValidity.country,
            productLineType: this.formData.assessmenType === 1 ? "All" : row.type,
            partnerType: this.partnerTypeAndContractValidity.partnerType,
            totalTarget: row.total
          };
          getCalculateTarget(params)
            .then(response => {
              let { status, data } = response;
              if (Number(status) === 200) {
                row.q1 = data.quarterlySplitVO.q1;
                row.q2 = data.quarterlySplitVO.q2;
                row.q3 = data.quarterlySplitVO.q3;
                row.q4 = data.quarterlySplitVO.q4;
                this.getTargetTotal(); // 计算总数
                this.formData.tableList.forEach(item => {
                  // 如果不是表格动季度数据的数据 那就需要赋值
                 this.getRebateLevel(item); // 计算返利系数
                });
              }
            })
            .catch(error => {
              console.log(error);
            });

        }

      }
    },
    getTargetTotal() {
      this.totalTarget = this.formData.tableList.reduce(
        (previousValue, currentValue) => {
          if (isNaN(currentValue.total)) {
            return previousValue;
          } else {
            return previousValue + currentValue.total;
          }
        },
        0
      );
    },
    getPercentage(num) {
      if (!num && num !== 0) return '-';
      return Big(getNum(num || 0))
        .times(100)
        .toFixed(2) + "%"
    },
    getAssessmentMethod (type) {

      switch (type) {
        case 1:
          return 'Overall Assessment';
        case 2:
          return 'Separate Assessment';
        default:
          return '-'
      }
    }
  }
};
</script>

<style scoped>
/deep/ .el-form-item.is-error {
  padding-bottom: 20px;
}

.text-content {
  width: 640px;
}
.tools-tip {
  color: #DD1D40;
  padding-left: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/salesTargetInformation.vue